<template>
  <div class="big-modal__backdrop">
    <div class="big-modal__container" :class="{ 'y-center': !isRegistrationBonuses }">
      <UiBtn
        class="big-modal__close"
        size="s"
        transparent
        icon="common/close"
        color="gray"
        :data-gtm-id="gmtId"
        data-id="big-modal-close"
        @click="closeBigModal"
      />
      <slot />
    </div>
    <BaseModalConfirm
      :value="infoModal && !get_isSuccessPasswordChange"
      :title="$tc('bigModal.modal.infoClose.title')"
      :text="$tc('bigModal.modal.infoClose.text')"
      :svg="{ name: 'common/warning', style: { color: 'var(--warning-500)'} }"
      @submit="closeModalAndCloseBigModal"
      @cancel="infoModal = false"
    >
      <template #controls="{ onCancel, onSubmit }">
        <UiBtn
          color="primary"
          :text="$t('bigModal.modal.infoClose.btn1')"
          @click="onCancel"
        />
        <UiBtn
          color="default"
          :text="$t('bigModal.modal.infoClose.btn2')"
          @click="onSubmit"
        />
      </template>
    </BaseModalConfirm>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'

import BaseModalConfirm from '~/components/Base/Modal/Confirm'
import { GTM_REG, GTM_REG_BONUS } from '@/constants/gtm'
import nuxtEmits from '~/constants/nuxtEmits.js'

export default {
  name: 'BigModal',
  components: { BaseModalConfirm },
  data() {
    return {
      infoModal: false,
    }
  },
  computed: {
    ...mapGetters('login', ['get_resultPasswordRequest', 'get_resultPasswordChange', 'get_isSuccessPasswordChange']),
    gmtId() {
      let res = ''
      if (this.$route.query?.bigModal === 'registration') res = GTM_REG.ID.ga_registration_click_close
      else if (this.$route.query?.bigModal === 'registrationBonuses') res = GTM_REG_BONUS.ID.ga_deposit_click_close
      return res
    },
    isRegistrationBonuses() {
      return this.$route.query?.bigModal === 'registrationBonuses'
    },
  },
  beforeMount() {
    disablePageScroll()
  },
  beforeDestroy() {
    enablePageScroll()
    this.$nuxt.$off(nuxtEmits.closeRegBonus)
  },
  methods: {
    ...mapActions('login', ['act_resultPasswordRequest', 'act_resultPasswordChange', 'act_isSuccessPasswordChange']),
    closeBigModal() {
      if (
        this.$route.query?.bigModal === 'resetPassword'
        && !this.get_isSuccessPasswordChange
        && (this.get_resultPasswordRequest || this.get_resultPasswordChange)
      ) {
        this.infoModal = true
        return
      }

      if (this.isRegistrationBonuses) {
        this.$nuxt.$emit(nuxtEmits.closeRegBonus)
        return
      }
      this.$newModal.closeBigModal()
    },
    closeModalAndCloseBigModal() {
      if (this.$route.query?.bigModal === 'resetPassword') {
        this.act_resultPasswordRequest(false)
        this.act_resultPasswordChange(false)
        this.act_isSuccessPasswordChange(false)
      }

      this.$newModal.closeBigModal()
      this.infoModal = false
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
